import styled from 'styled-components';

import { LegacyTooltip } from 'components/LegacyTooltip/LegacyTooltip';
import { colors } from 'theme/theme';

export const StyledTooltip = styled(LegacyTooltip)`
  bottom: 2px;
  margin-left: 10px;
`;

export const SplitSection = styled.div`
  border-top: 1px solid ${colors.selectionGrey};
  display: flex;
  flex-direction: row;
  margin: 0 -70px;
  padding: 30px 10px 0;
`;

export const ChartDetailsContainer = styled.div`
  display: flex;
  gap: 15px;
  flex-direction: column;
  text-align: left;
`;

export const LeftSection = styled.div`
  flex: 2;
  padding-left: 60px;

  ${ChartDetailsContainer} {
    border-right: 1px solid ${colors.selectionGrey};
    padding-right: 50px;
  }
`;

export const RightSection = styled.div`
  flex: 3;
  padding-right: 60px;

  h4,
  ${ChartDetailsContainer} {
    padding-left: 50px;
  }
`;

export const ChartDetailContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
